import { getResult } from './utils.js';

async function fetchIt(endpoint, body = null, method = null, headers = null, blob = false, configUrl = false, withCredentials = true, returnJson = true, returnReult = true) {
    method = (method || "GET").toUpperCase();
    // 2) choose the URL
    const url = endpoint;
    // 3) prepare headers & body
    headers = {
        ...(body instanceof FormData ? {} : { "Content-Type": "application/json" }),
        ...headers,
    };
    const opts = {
        method,
        credentials: withCredentials ? "include" : "same-origin",
        headers,
        body: body instanceof FormData
            ? body
            : body != null && method !== "GET"
                ? JSON.stringify(body)
                : undefined,
    };
    console.debug("➡️ secureFetchIt →", url, opts);
    const res = await fetch(url, opts);
    if (!res.ok) {
        const err = await res.text();
        throw new Error(`HTTP ${res.status}: ${err}`);
    }
    if (blob)
        return res.blob();
    if (returnReult)
        return getResult(res.json());
    if (returnJson)
        return res.json();
    return res;
}
// Constructs HTML directory path
function getHtmlDirectory(directory, filename) {
    return `${directory}/${filename}.html`;
}
// Fetches HTML content
async function fetchIndexHtml(filename, directory = 'sf_index', base = 'html') {
    const url = `/${base}/${directory}/${filename}.html`;
    const response = await fetch(url);
    return await response.text();
}
// Fetches and injects HTML content into container
async function fetchIndexHtmlContainer(filename, doc = document, directory = 'html') {
    const container = `${filename}-container`;
    const html = await fetchIndexHtml(filename, directory);
    const el = doc.getElementById(container);
    if (el) {
        el.innerHTML = html;
    }
    else {
        console.warn(`⚠️ No container found for: #${container}`);
    }
}

export { fetchIndexHtml, fetchIndexHtmlContainer, fetchIt, getHtmlDirectory };
//# sourceMappingURL=fetch_utils.js.map
